import { createSlice } from "@reduxjs/toolkit";
import {GetAllMealtimes, GetTotalMealsKpisGrid, GetTotalMealsKpisList} from "./FoodieOrdersApi";
import {ResponseApi} from "../BaseApi";

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */


const FoodieOrdersSlice = createSlice({
    name: 'foodieMealTimes',
    initialState: {
        mealtimes: [],
        loading: false,
        error: null,
        getTotalMealsKpisList: null,
        getTotalMealsKpisGrid: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GetAllMealtimes.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetAllMealtimes.fulfilled, (state, action) => {
                state.loading = false;
                state.mealtimes = action.payload.data || [];
            })
            .addCase(GetAllMealtimes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(GetTotalMealsKpisList.fulfilled, (state, { payload }) => {
                state.getTotalMealsKpisList = ResponseApi(payload);
            })
            .addCase(GetTotalMealsKpisGrid.fulfilled, (state, { payload }) => {
                state.getTotalMealsKpisGrid = ResponseApi(payload);
            });
    },
})

export default FoodieOrdersSlice.reducer;
